import { fetchCustomerDetail } from '#/api/crmMgmt/customer/fetchDetail';
import { fetchCustomerList } from '#/api/crmMgmt/customer/fetchList';
import { mapCustomerRowsToSelectOptions } from '#/api/crmMgmt/customer/fetchSelectOptions';
import { coerceFilterValues } from '#/modules/commonComponents/table/columnFilterUtils';

function resolveCustomerLabel(customer) {
  if (!customer) {
    return '-';
  }
  return [customer.code, customer.name].filter(Boolean).join(' - ') || '-';
}

/**
 * customer async multi filter options（ACTIVE 客戶）。
 * @param {{ keyword?: string }} param0
 */
export async function searchCustomerFilterOptions({ keyword }) {
  const result = await fetchCustomerList({
    page: 1,
    pageSize: 20,
    keyword: keyword ?? '',
    sort: [],
    filters: { status: 'ACTIVE' },
  });

  return mapCustomerRowsToSelectOptions(result.data ?? []);
}

/**
 * URL 已有 customerId 但 label cache 空時，依 id 補 label。
 * @returns {Promise<boolean>} 是否有寫入新 label（用於觸發重渲染）
 */
export async function hydrateCustomerFilterLabels(ids, labelCache) {
  if (!labelCache) {
    return false;
  }

  const missing = coerceFilterValues(ids).filter((id) => !labelCache.has(String(id)));
  if (missing.length === 0) {
    return false;
  }

  await Promise.all(missing.map(async (id) => {
    try {
      const result = await fetchCustomerDetail(id);
      const label = resolveCustomerLabel(result?.data);
      labelCache.set(String(id), label);
    } catch {
      // 留下 unresolved；ListFilterStatus 會顯示「已選 N 項」
    }
  }));

  return missing.some((id) => labelCache.has(String(id)));
}
